import validate from '../../../services/reduxValidate.js'

export default function(data) {
  return validate(data, {
    description: { presence: { allowEmpty: false } },
    year: { isoDate: true }
  })
}